import React, { useImperativeHandle, useState } from "react";
import { Button, Input } from "./Elements";
import Modal from "./Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import paymentApi from "../../common/api/paymentApi";
import Loading from "./Loading";
import { USER_ID } from "../../constants/storageKeys";


type Props = {
    hideAmountInput?: boolean,
    licenseKey: string,
    taxCode: string
}

export interface InstallmentHtmlTableRefProps {
    openModal: (initialAmount?: string) => void
}
const InstallmentHtmlTable = React.forwardRef<InstallmentHtmlTableRefProps, Props>((props: Props, ref) => {

    var userId = localStorage.getItem(USER_ID) || 0;

    const [isModalVisible, setIsModalVisible] = useState(false);
    const [fields, setFields] = useState({
        amount: "100.00"
    });
    const [htmlTable, setHtmlTable] = useState("");
    const [loadingVisible, setLoadingVisible] = useState(false);
    useImperativeHandle(ref, () => ({

        openModal(initialAmount) {
            selectHtmlTable(initialAmount);
            setIsModalVisible(true);
            setLoadingVisible(true);
            setHtmlTable("");

        }

    }));

    const selectHtmlTable = async (initialAmount?: string) => {
        const amount = initialAmount ? initialAmount : fields.amount

        const params = {
            amount: amount ? amount.toString().replaceAll(",", '').replaceAll(".", '') : "10000",
            userId: userId,
        }
        const apiParams = {
            licenseKey: props.licenseKey,
            taxCode:props.taxCode
        }

        const response = await paymentApi.get("/installments/html-table", params, apiParams);
        setLoadingVisible(false);

        if (response?.isSuccess) {
            setHtmlTable(response?.data);
        }

    }
    const onChangeField = (event: any) => {

        setFields({
            amount: event.target.value
        });
    }


    return (
        <Modal dialogclassName={"!max-w-[1200px] !mt-16"} openModal={isModalVisible} setOpenModal={() => setIsModalVisible(false)} >
            <div>
                <div className="sm:flex sm:items-start">
                    <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left w-[100%] min-w-[400px] min-h-[450px]">
                        <div className="flex justify-between">
                            <div></div>
                            <h3 className="text-md leading-6 font-medium text-gray-900">
                                Tüm Taksit Seçenekleri
                            </h3>
                            <div>

                                <FontAwesomeIcon icon={faXmark} className="cursor-pointer" fontSize={18} onClick={() => setIsModalVisible(false)} />

                            </div>
                        </div>

                        {props.hideAmountInput != true && (
                            <div className="flex w-100 ml-[25px] mb-5">
                                <div className="flex justify-start">
                                    <div className="">
                                        <Input
                                            name={`amount`}
                                            value={fields.amount}
                                            type="text"
                                            currencyformat
                                            className="w-[100%]"
                                            label="Görüntülemek İstediğiniz Tutarı Giriniz"
                                            onChange={onChangeField}
                                            rightButton={
                                                <div className="ml-2">
                                                    <Button
                                                        color="primary"
                                                        hover="primary"
                                                        size="xs"
                                                        loading={loadingVisible}
                                                        callback={() => selectHtmlTable()}
                                                    >
                                                        Ön İzle
                                                    </Button>
                                                </div>
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                        )}
   {(loadingVisible && props.hideAmountInput) &&(
                                <Loading desc="Taksit listesi yükleniyor..."  />
                            )}
                        <div dangerouslySetInnerHTML={{
                            __html: htmlTable
                        }}>
                         
                        </div>
                    </div>
                </div>
                <div className="mt-5 sm:mt-4 flex justify-end space-x-2">
                    <Button
                        color="gray"
                        hover="gray"
                        size="xs"
                        callback={() => setIsModalVisible(false)}
                    >
                        Kapat
                    </Button>
                </div>
            </div>
        </Modal>
    );
})

export default InstallmentHtmlTable;


String.prototype.replaceAll = function (search: any, replacement: any) {
    var target = this;
    var result: string = target.split(search).join(replacement);
    return result;
};